export const appConstants = {
  //BACKEND_URL: "http://127.0.0.1:8000/api/",
  BACKEND_URL: "https://utechnolabs.com/api/api/",
  FRONTEND_URL: "http://localhost:3000",
  // FRONTEND_URL: "https://utechnolabs.com",

  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  FORGOT_REQUEST: "USERS_FORGOT_REQUEST",
  FORGOT_SUCCESS: "USERS_FORGOT_SUCCESS",
  FORGOT_FAILURE: "USERS_FORGOT_FAILURE",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  CLEAR: "ALERT_CLEAR",
  LOGOUT: "USERS_LOGOUT",
  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",
  GET_HOME_DATA: "GET_HOME_DATA",
  GET_HOME_NEW_DATA: "GET_HOME_NEW_DATA",
  GET_ERRORS: "GET_ERRORS",
  GET_STOCK_DATA: "GET_STOCK_DATA",
  GET_REAL_DATA: "GET_REAL_DATA",
};

export const loaderDispatch = (dispatch, condition, ftype = "") => {
  dispatch({
    type: "LOADER",
    payload: condition,
    ftype: ftype,
  });
};

//   var lang = 1;
//   if (localStorage.getItem("selectedLang") !== null) {
//     var langv = JSON.parse(localStorage.getItem("selectedLang"));
//     lang = langv.id;
//   }

export const config = {
  headers: {
    "Content-type": "application/json",
    //   "X-localization": `${lang}`,
  },
};

export const options = (
  stockSymb,
  stockDatas,
  annotateClose,
  annotationList,
  shape,
  label,
) => {

  const op = {
    chart: {
      borderWidth: 0,
      plotBorderWidth: 1,
      zoomType: 'xy',
      resetZoomButton: {
        position: {
            align: 'left', 
            // verticalAlign: 'top', // by default
            x: 264,
            y: -40
          }
        },
      panning: true,
      panKey: 'shift',
      spacingRight: window.innerWidth * 0.05,
      height: 800,
      type: "line",
      animation: {
        duration: 1000
      }
    },
    xAxis: {
      alternateGridColor: 'rgba(0, 0, 0, 5%)',
      label: {
        enabled: true, text: "footer"
      },
      scrollbar: { 
        enabled: false 
      },
      type: "datetime",
    },
    rangeSelector: {
      enabled: true,
      inputEnabled: true,
      selected: 5,
    },
    navigator: {
      enabled: false,
    },
    yAxis: {
      title: {
        //text: "Closing Price: " + stockSymb,
      },
      labels: {
          align: 'left',
          x: 12,
          y: 4
      }

    },
    title: {
      // text: "Stock Price with Timezone: " + stockSymb,
    },
    
    series: [
      {
        type: "line",
        color: 'rgba(0, 0, 0, 0.40)',
        name: stockSymb + " Symbol Data of Last 2 Year",
        data: stockDatas,
      },
    ],
   
    annotations: annotationList,
  };
  return op;
};

export const shiftPos = (symbolArr, symbol) => {
  var element = symbolArr[symbolArr.indexOf(symbol)];
  symbolArr.splice(symbolArr.indexOf(symbol), 1);
  symbolArr.splice(0, 0, element);
  return symbolArr;
};
